/** Pure nav builders for permission-gated main menu (and home redirect). */

export type NavChild = { label: string; to: string; value: string };
export type NavItem = {
    label: string;
    to: string;
    value: string;
    children?: NavChild[];
};

export type FeatureNavAccess = {
    leads: boolean;
    quotes: boolean;
    projects: boolean;
    contractors: boolean;
    tickets: boolean;
    cards: boolean;
    receiptUpload: boolean;
    receiptAdmin: boolean;
};

/** Feature tabs only (excludes Home). Dropdown parents use `to` of the first allowed child. */
export function buildFeatureNavItems(access: FeatureNavAccess): NavItem[] {
    const receiptChildren: NavChild[] = [
        ...(access.receiptUpload
            ? [{ label: 'Upload', to: '/receipts', value: '/receipts' }]
            : []),
        ...(access.receiptAdmin
            ? [
                  {
                      label: 'Admin',
                      to: '/receipts/admin',
                      value: '/receipts/admin',
                  },
                  {
                      label: 'QuickBooks Classes',
                      to: '/receipts/classes',
                      value: '/receipts/classes',
                  },
              ]
            : []),
    ];
    const showReceipts = receiptChildren.length > 0;

    return [
        ...(access.leads
            ? [{ label: 'Leads', to: '/leads', value: '/leads' }]
            : []),
        ...(access.quotes
            ? [{ label: 'Quotes', to: '/quotes', value: '/quotes' }]
            : []),
        ...(access.projects
            ? [{ label: 'Projects', to: '/projects', value: '/projects' }]
            : []),
        ...(access.contractors
            ? [
                  {
                      label: 'Contractors',
                      to: '/contractor_owners',
                      value: '/contractor_owners',
                  },
              ]
            : []),
        ...(access.tickets
            ? [{ label: 'Tickets', to: '/tickets', value: '/tickets' }]
            : []),
        ...(access.cards
            ? [{ label: 'Job Board', to: '/cards', value: '/cards' }]
            : []),
        ...(showReceipts
            ? [
                  {
                      label: 'Receipts',
                      to: receiptChildren[0].to,
                      value: '/receipts',
                      children: receiptChildren,
                  },
              ]
            : []),
    ];
}

/** When home has no widgets and exactly one feature menu, go there (uses parent `to` for dropdowns). */
export function soleFeatureRedirectTo(
    hasHomeWidgets: boolean,
    featureItems: ReadonlyArray<Pick<NavItem, 'to'>>
): string | null {
    if (hasHomeWidgets) return null;
    if (featureItems.length !== 1) return null;
    return featureItems[0].to;
}
